const toSlug = (string) => {
  // replace all whitesapce with -
  const regex = /(\s|_|\/)/
  const formattedString = string.replace(regex, "-")
  return formattedString.toLowerCase()
}

export default toSlug
